import PageHero from "@/components/PageHero";
import SEO from "@/components/SEO";

const SECTIONS = [
  {
    title: "Website Information",
    body: "This website is published by Gopi Gadhvi Group to introduce its ventures and facilitate enquiries. Content is provided for general informational purposes and is updated periodically.",
  },
  {
    title: "No Professional Guarantee",
    body: "Nothing on this website constitutes financial, investment, legal or professional advice. Any engagement with a Gopi Gadhvi Group venture is subject to separate terms agreed directly with that venture.",
  },
  {
    title: "Intellectual Property",
    body: "All logos, trademarks, copy and visual assets on this website belong to Gopi Gadhvi Group or its respective ventures and may not be reproduced without permission.",
  },
  {
    title: "External Venture Links",
    body: "Links to The Art Forest, The Wishing Well and other external destinations are provided for convenience. Gopi Gadhvi Group is not responsible for the content or practices of independently operated external websites.",
  },
  {
    title: "Acceptable Use",
    body: "Visitors agree not to misuse this website, attempt unauthorised access, or submit false, harmful or spam content through the enquiry form.",
  },
  {
    title: "Accuracy and Availability",
    body: "While we take reasonable care to keep information accurate and the website available, we do not guarantee uninterrupted access or that all content is free of error at all times.",
  },
  {
    title: "Limitation of Liability",
    body: "To the fullest extent permitted by law, Gopi Gadhvi Group is not liable for any indirect or consequential loss arising from use of this website.",
  },
  {
    title: "Governing Law",
    body: "These terms are intended to be governed by the laws of India, subject to confirmation upon professional legal review.",
  },
  {
    title: "Updates to Terms",
    body: "These terms may be revised periodically. Continued use of the website after an update constitutes acceptance of the revised terms.",
  },
];

const Terms = () => {
  return (
    <div data-testid="page-terms">
      <SEO title="Terms of Use" description="Terms governing use of the Gopi Gadhvi Group website." path="/terms" />
      <PageHero eyebrow="Legal" heading="Terms of Use" minHeight="32vh" />

      <section className="relative page-shell pb-28">
        <div className="editorial-col mx-auto space-y-10">
          <p className="text-small" data-testid="terms-legal-review-note">
            This page is marked for professional legal review before final publication and does not
            constitute legal advice.
          </p>
          {SECTIONS.map((s) => (
            <div key={s.title}>
              <h2 className="text-h4 mb-3">{s.title}</h2>
              <p className="text-body text-justify">{s.body}</p>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
};

export default Terms;
